export const MATCHING_PROFILES_URL = '/settings/matching-profiles'
export const MATCHING_PROFILES_API = '/api/internal/matching/profiles'

export const MATCHING_PROFILES_BREADCRUMBS = [
  { title: 'Настройки', path: '/settings' },
  { title: 'Профили мэтчинга', path: MATCHING_PROFILES_URL },
]
